import classNames from "classnames";
import React from "react";
import Icon from "../Icon";
import { injectIntl } from "react-intl";
var ColorModeSwitcher = function(param) {
    var colorMode = param.colorMode, intl = param.intl, onClick = param.onClick, selectedColorMode = param.selectedColorMode;
    var classes = classNames("color-mode", colorMode, {
        selected: colorMode === selectedColorMode
    });
    var label = intl.formatMessage({
        id: "accessibility.color_mode.".concat(colorMode),
        defaultMessage: colorMode
    });
    return /*#__PURE__*/ React.createElement("button", {
        className: classes,
        onClick: onClick,
        "aria-label": label
    }, /*#__PURE__*/ React.createElement(Icon, {
        className: "color-mode__icon",
        name: "".concat(colorMode, "-color-mode"),
        size: "xl"
    }), /*#__PURE__*/ React.createElement("span", {
        className: "color-mode__name"
    }, label));
};
export default injectIntl(ColorModeSwitcher);
